










import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';
import * as Components from '@/tenant/components';

@Component
export default class LicenseReportDialog extends Vue {
 @Prop({ default: null }) public template: Common.ReportTemplate;
  public query : Common.LicenseReportQuery = new Common.LicenseReportQuery();
  public startDate: Date = null;
  public endDate: Date = null;  
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;

  public mounted(){
      this.startDateFlag = Common.dateFlags.current_month_begin;
      this.endDateFlag = Common.dateFlags.current_month_end;      
  }
  public async onReportGenerate(){
    // クエリの設定
    this.query.templateId = this.template.id;
    this.query.startDate = this.startDate;
    this.query.endDate = this.endDate;
    this.$api.download(this.query);
  }
  public onHidden(){
      this.$emit('hidden');
  }  
}
